// Main page template wrapping each page

import { Link } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import User from './User';
import Chats from './Chats';
import ScrollToTopButton from './ScrollToTopButton';
import TrailBar from './TrailBar';
import logo from '../assets/images/logo-512-white.png';
import './Layout.scss';

export default function Layout({
  screenSized,
  trail,
  className,
  children,
  noUser,
}) {
  return (
    <>
      <ScrollToTop />
      <ScrollToTopButton />
      <div
        className={
          'layout' +
          (screenSized ? ' screen-sized' : '') +
          (className ? ' ' + className : '')
        }
      >
        <section className='layout-header'>
          <div className='container'>
            <Link to='/'>
              <div
                className='bg-image wh-64'
                style={{ backgroundImage: `url(${logo})` }}
              />
            </Link>
            {!noUser && (
              <div className='header-user'>
                <Chats />
                <User />
              </div>
            )}
          </div>
        </section>
        {trail && (
          <section className='layout-trailbar'>
            <div className='container'>
              <TrailBar />
            </div>
          </section>
        )}
        <section className='layout-body'>
          <div className='container'>{children}</div>
        </section>
        <section className='layout-footer'>
          <div className='container'>
            <p>© Muva</p>
            <p>
              Questions or feedback? Contact the developer,{' '}
              <span className='footer-name'>Vlad Zadovsky</span>, at{' '}
              <a href='mailto:vlad@themuva.com'>vlad@themuva.com</a>
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
